export class ApiError extends Error {
  readonly messages: string[]

  constructor(messages: string[] | undefined) {
    const safe = (messages ?? []).map((message) => message.trim()).filter(Boolean)
    super(safe.join(' ') || 'Request failed')
    this.name = 'ApiError'
    this.messages = safe.length ? safe : ['Request failed']
  }
}
